import { useTranslation } from 'react-i18next';

export default function Spinner({ size = 'md', text, className = '' }) {
  const { t } = useTranslation('common');

  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className={`text-center py-8 ${className}`}>
      <div className={`animate-spin rounded-full ${sizeClasses[size]} border-b-2 border-indigo-600 mx-auto`} />
      {text !== false && (
        <p className="mt-2 text-sm text-gray-500">
          {text || t('text.loading')}
        </p>
      )}
    </div>
  );
}
